<mat-accordion>
    <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h3>Data filtering configuration</h3>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <rules-data-filter [parentFormGroup]="form" [sectionConfig]="sectionConfig"></rules-data-filter>
        <apps-data-filter [parentFormGroup]="form" [sectionConfig]="sectionConfig"></apps-data-filter>        
    </mat-expansion-panel>
</mat-accordion>